window.addEventListener("load", () => {
  const reviewDescriptions = document.querySelectorAll(".description");
  const descriptionSeeMore = document.querySelectorAll(".description-seemore");

  let isExpanded = false;

  reviewDescriptions.forEach((reviewDescription, index) => {
    const seeMore = descriptionSeeMore[index];

    if (!seeMore) {
      return;
    }

    const styles = getComputedStyle(reviewDescription);
    const lineHeight = parseFloat(styles.lineHeight);
    const maxHeight = lineHeight * 4;

    if (reviewDescription.scrollHeight > maxHeight) {
      seeMore.classList.remove("mtgtw:hidden!");
    }
  });

  descriptionSeeMore.forEach((seeMore) => {
    seeMore.addEventListener("click", () => {
      isExpanded = !isExpanded;

      reviewDescriptions.forEach((reviewDescription) => {
        if (isExpanded) {
          reviewDescription.classList.remove("mtgtw:line-clamp-4!");
        } else {
          reviewDescription.classList.add("mtgtw:line-clamp-4!");
        }
      });

      descriptionSeeMore.forEach((button) => {
        button.textContent = isExpanded ? "See less" : "See more";
      });

      const swiperWrappers = document.querySelectorAll(".swiper-wrapper");

      swiperWrappers.forEach((wrapper) => {
        wrapper.style.height = "100%";
      });
    });
  });
});
